export default {"src":"/_next/static/media/w.8ca7af48.svg","height":311,"width":388,"blurWidth":0,"blurHeight":0};